import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { FeatureGrid } from './components/FeatureGrid';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialGrid } from './components/TestimonialGrid';
import { FAQAccordion } from './components/FAQAccordion';
import { CTAButton } from './components/CTAButton';
import { PriceDisplay } from './components/PriceDisplay';
export function App() {
  useEffect(() => {
    // UTMify Pixel
    ;
    (window as any).pixelId = '69828c3d35b55b151494d578';
    const utmScript = document.createElement('script');
    utmScript.setAttribute('async', '');
    utmScript.setAttribute('defer', '');
    utmScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(utmScript);
  }, []);
  return <div className="min-h-screen bg-[#0d0d0d] text-white font-sans selection:bg-[#FF6B00] selection:text-white" data-id="element-0">
      <div className="fixed inset-0 z-0 metal-texture opacity-30 pointer-events-none mix-blend-overlay" data-id="element-1" />

      <div className="relative z-10" data-id="element-2">
        <StickyAlertBar data-id="element-3" />

        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <SalesLetter data-id="element-6" />
          <FeatureGrid data-id="element-7" />
          <TestimonialGrid data-id="element-8" />
          <BonusSection data-id="element-9" />
          <PricingSection data-id="element-10" />
          <FAQAccordion data-id="element-11" />

          {/* Final CTA */}
          <section className="py-6 px-4 bg-[#111] text-center border-t border-[#333]" data-id="element-12">
            <p className="text-sm text-gray-400 mb-1 uppercase tracking-wider" data-id="element-13">
              PRECIO DE HOY:
            </p>
            <PriceDisplay amount={16.99} className="text-5xl font-bold text-[#FF6B00] mb-3 block" data-id="element-14" />
            <CTAButton size="xl" className="mb-3" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-15">
              AGREGAR AL CARRITO
            </CTAButton>
            <p className="text-sm text-gray-400" data-id="element-16">
              Empezá Tu Próximo Proyecto Hoy &gt;&gt;
            </p>
            <p className="text-xs text-gray-500 mt-2" data-id="element-17">
              Pago único. SIN cargos mensuales.
            </p>
          </section>
        </main>

        <footer className="bg-[#0a0a0a] py-6 px-4 border-t border-[#333] text-center" data-id="element-18">
          <div className="max-w-4xl mx-auto" data-id="element-19">
            <div className="text-xs text-gray-600 space-y-2" data-id="element-20">
              <p data-id="element-21">
                © Sistema Maestro de Herrería — Todos los Derechos Reservados
              </p>
              <div className="flex justify-center gap-4" data-id="element-22">
                <a href="#" className="hover:text-gray-400" data-id="element-23">
                  Contacto
                </a>
                <a href="#" className="hover:text-gray-400" data-id="element-24">
                  Política de Privacidad
                </a>
                <a href="#" className="hover:text-gray-400" data-id="element-25">
                  Términos y Condiciones
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}